import React from 'react';
import '../App.css'

export default function Contact() {
    return (
        <>
        <div id="contact"></div>
        <section className="contact_section">
            <h1 className="section_title">About Me</h1>

            <div className="contact_grid">
                <div className="contact_card">
                    <div className="contact_pfp">
                        <img src="images/sofyan_pfp.jpeg" alt="Soufiane El-Mouaffaq" />
                    </div>
                    <div className="contact_meta">
                        <h3>Soufiane El‑Mouaffaq</h3>
                        <p className="contact_role">Arabic Instructor — Online Classes</p>
                        <div className="contact_actions">
                            <a href="mailto:soufianeelmouaffaq@gmail.com" className="btn btn--primary">Email</a>
                            <a href="https://wa.me/" target="_blank" rel="noreferrer" className="btn btn--outline">Message</a>
                        </div>
                    </div>
                </div>

                <article className="contact_bio">
                    <p>
                        Hello, I'm Soufiane, a passionate Arabic educator from Morocco. I began teaching online during the pandemic and have since helped students worldwide improve their Modern Standard and Classical Arabic. My lessons are tailored to your goals — whether Quranic reading, conversation, or grammar.
                    </p>

                    <p>
                        Lessons are scheduled flexibly between 8am and 5pm EST. I use proven textbooks (Madinah, Al‑Kitaab, Mastering Arabic) and personalized exercises to ensure steady progress.
                    </p>

                    <div className="contact_card contact_contact">
                        <h4>Contact Me</h4>
                        <p>Send an email to <a href="mailto:soufianeelmouaffaq@gmail.com">soufianeelmouaffaq@gmail.com</a> or use the message button above. I usually reply within 24 hours.</p>
                    </div>
                </article>
            </div>
        </section>
        </>
    );
}

